export default "__VITE_ASSET__CGrE0eCx__"